<template>
  <div id="app">
    <header-nav @changeContent='changeContent'></header-nav>
    <div id="logo"></div>
    <component :is='currentComponent'></component>
    <footer>
      <span>© 1999-2018 Maki Amayumi</span>
      <social></social>
    </footer>
  </div>
</template>

<script>
import TopPage from "./components/TopPage.vue";
import HeaderNav from "./components/HeaderNav.vue";
import Social from "./components/Social.vue";
import Contact from "./components/Contact.vue";

export default {
  name: "App",
  components: {
    HeaderNav, TopPage,Contact, Social
  },
  methods:{
    changeContent(name){
      this.currentComponent = name;
    }
  },
  data(){
    return {
      currentComponent: 'top-page'
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", "Helvetica Neue", "Helvetica", "Arial", "Hiragino Sans",
    "ヒラギノ角ゴシック", YuGothic, "Yu Gothic", "メイリオ", Meiryo,
    "ＭＳ Ｐゴシック", "MS PGothic";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fafafa;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -5;

  background-image: url('./assets/bg_top.jpg');
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}
#logo {
  z-index: 1;
  pointer-events: none;
  display: block;
  position: absolute;
  top: calc(50px + 2vh);
  left: calc(40% - (100px + 10vmin));
  width: calc(100px + 10vmin);
  height: calc(100px + 10vmin);
  margin: 5px;
  background-image: url('./assets/logo.png');
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
#main-conent {
  width: 100%;
  margin: 0;
  padding: 0;
  display: inline-flex;
}

footer {
  display: inline-flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc(50px + 2%);
  background-color: #07000a;
}
footer span {
  font-size: calc(0.5em + 1vw);
  margin-left: 1em;
}

a {
  color: #00f8b2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue